<template>

    <article class="sub">

        <div class="row">
            <img src="/img/newsletters-v2/later-blue.svg"
                 class="img__20"
                 v-show="subscription.type === ENUM.NEWSLETTERS.CATEGORIES.LATER"
                 :data-highlight="isMainCard && subscription.type === ENUM.NEWSLETTERS.CATEGORIES.LATER ? ENUM.HIGHLIGHT.NEW_SENDER: ''">
            <span class="text-xlSemibold ellipsis-text"
                  :style="nameStyle"
                  :title="subscription.name">{{subscription.name}}</span>
        </div>
        <span class="text-lRegular color__moon ellipsis-text" :title="subscription.sender">{{subscription.sender}}</span>
        <div class="tags">
            <div class="tag email">{{subscription.email}}</div>
            <div class="tag spoum" v-if="Subscription.isSpoum(subscription)">{{ $t('spam') }}</div>
            <div class="tag not-seen" v-if="subscription.notSeen" :data-highlight="isMainCard ? ENUM.HIGHLIGHT.NOT_SEEN : ''">{{ $t('new_mail_received') }}</div>
        </div>
        <div class="content">
            <div class="bloc bloc-1">
                <span :class="{'title-baseSemibold': !isDesktop, 'title-lSemibold': isDesktop, }">{{ subscription.openRate || 0 }} %</span>
                <span :class="{'text-baseRegular': !isDesktop, 'text-lRegular': isDesktop, }">{{$t('cleaning_cards_opening_rate')}}</span>
            </div>
            <div class="spacer"></div>
            <div class="bloc bloc-2">
                <span :class="{'title-baseSemibold': !isDesktop, 'title-lSemibold': isDesktop, }">{{ subscription.count }}</span>
                <span :class="{'text-baseRegular': !isDesktop, 'text-lRegular': isDesktop, }">{{ $tc('cleaning_cards_received_emails', subscription.count)}}</span>
            </div>
        </div>
    </article>

</template>

<script>
import Subscription from '@/helpers/subscription'

import ENUM from '../../../assets/ENUM'


export default {

    name: 'subscriptions',

    props: {
        subscription: {
            type: Object,
            default: () => {
                return {}
            }
        },

        isMainCard: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        Subscription() {
            return Subscription
        },

        ENUM() {
            return ENUM
        },

        nameStyle() {
            if(this.subscription.type === ENUM.NEWSLETTERS.CATEGORIES.LATER) {
                return this.isReverseLang
                    ? 'margin-left: 8px;'
                    : 'margin-right: 8px;'
            }
        }
    }
}

</script>

<style lang="scss" scoped>

.sub {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 24px 20px;
    background-color: $white;
    border-radius: 12px;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.12), 0px 8px 32px 0px rgba(0, 0, 0, 0.04);
    text-align: start;
    overflow: hidden;
    @media screen and (min-width: $above-tablet-length) {
        padding: 32px;
    }

    .row {
        background-color: $white;
        display: flex;
        flex-direction: row;
        > img {
            margin-right: 8px;
            &:lang(ar-sa) {
                margin-right: 0;
                margin-left: 8px;
            }
        }
    }

    .tags {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 12px;
        }

        .tag {
            margin-top: 4px;
            padding: 2px 8px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            border-radius: 16px;
            font-size: 15px;
            font-weight: 600;
            margin-right: 4px;
        }

        .email {
            background-color: $timberwolf;
            color: $aquamarine;
        }

        .spoum {
            background-color: $lavender-blush;
            color: $raspberry;
        }

        .not-seen {
            background-color: $chardon;
            color: $sunset;
        }
    }

    .content {
        margin-top: 16px;
        display: flex;
        flex-direction: row;
        flex: 1;

        .spacer {
            width: 4px;
        }

        .bloc {
            padding: 12px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            border-radius: 12px;
            color: $white;
            text-align: start;
        }

        .bloc-1 {
            background: linear-gradient(125deg, #85B0F1 0%, #69D7FF 100%);
        }

        .bloc-2 {
            background: linear-gradient(143deg, #6ECA89 0%, #6DC6FF 100%);
        }
    }
}


</style>
